import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap, throwError } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IRoomType } from "./iroomtype";


@Injectable({ providedIn: 'root' })
export class RoomTypeService {

    private _roomtype: BehaviorSubject<IRoomType | null> = new BehaviorSubject<IRoomType | null>(null);
    private _roomtypes: BehaviorSubject<IRoomType[]> = new BehaviorSubject<IRoomType[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get roomtype$(): Observable<IRoomType | null> {
        return this._roomtype.asObservable();
    }

    get roomtypes$(): Observable<IRoomType[]> {
        return this._roomtypes.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }

    getAllRoomTypes(roomtype: PaginationRequest & { wardId?: number | null }): Observable<BaseRespone<{ pagination: PaginationResult; roomTypeDetails: IRoomType[] }>> {
        const requestBody = { ...roomtype };

        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; roomTypeDetails: IRoomType[] }>>(`${environment.baseURl}/RoomType/list`, requestBody).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._roomtypes.next(response.result.roomTypeDetails);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createRoomType(roomtypeDetails: IRoomType): Observable<BaseRespone<IRoomType>> {
        return this._httpClient.post<BaseRespone<IRoomType>>(`${environment.baseURl}/RoomType`, roomtypeDetails)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    deleteRoomType(id: number): Observable<BaseRespone<boolean>> {
        return this.roomtypes$.pipe(
            take(1),
            switchMap(roomtype =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/RoomType/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = roomtype.filter(item => item.id !== id);
                            this._roomtypes.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateRoomType(roomtypeDetails: IRoomType): Observable<BaseRespone<IRoomType>> {
        return this.roomtypes$.pipe(
            take(1),
            switchMap(roomtypes => this._httpClient.put<BaseRespone<IRoomType>>(`${environment.baseURl}/RoomType`, roomtypeDetails).pipe(
                map((updated: BaseRespone<IRoomType>) => {
                    // Find the index of the updated product
                    const index = roomtypes.findIndex(item => item.id === roomtypeDetails.id);

                    // Update the product
                    roomtypes[index] = roomtypeDetails;

                    // Update the products
                    this._roomtypes.next(roomtypes);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }
}